import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { RevolvingStore } from '../services/revolving.store';
import { PrintStore } from '@app/@shared';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Subscription } from 'rxjs';
import { MAX_SELECTOR_DATA } from '@app/@core/constants/material-custom.constants';

@Component({
  selector: 'app-refunds',
  templateUrl: './refunds.component.html',
  styleUrls: ['./refunds.component.scss'],
})
export class RefundsComponent implements OnInit, OnDestroy {
  public refundDataForm: FormGroup;
  public establishmentsList: CommonDataDTO[] = [];
  isInputFocused: boolean = false;
  amount: string = '';
  formattedAmount: string = '';

  constructor(
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    public dialog: MatDialog,
    private combosStore: CombosStore,
    private revolvingStore: RevolvingStore,
    private printStore: PrintStore,
    private customValidators: CustomValidatorsService
  ) {}

  ngOnDestroy(): void {}

  ngOnInit(): void {
    this.refundDataForm = this.formBuilder.group(
      {
        establishment: ['', Validators.required],
        contractNum: ['', Validators.required],
        authorizationNum: ['', Validators.required],
        nifNie: ['', [Validators.required, this.customValidators.isNifNieValid]],
        description: [{ value: '', disabled: true }],
        refundImport: ['', Validators.required],
      },
      { updateOn: 'blur' }
    );

    this.combosStore.getEstablishments().then(
      (data) => {
        if (data) {
          if (data.length === 1) this.refundDataForm.controls.establishment.setValue(data[0]?.id);
          this.establishmentsList = data;
        }
      },
      (error) => console.error(error)
    );
  }

  getDescription() {
    if (
      this.refundDataForm.controls.establishment?.value &&
      this.refundDataForm.controls.contractNum?.value &&
      this.refundDataForm.controls.authorizationNum?.value &&
      this.refundDataForm.controls.nifNie?.value
    ) {
      this.revolvingStore.getDescriptionPurchase(this.refundDataForm).then(
        (data) => {
          this.refundDataForm.controls.description.setValue(data);
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  focusComponentForm = () => {
    this.isInputFocused = true;
  };

  focusOutComponentForm = () => {
    this.isInputFocused = false;
  };

  cancelClick() {
    console.log('cancel');
    this.refundDataForm.reset();
  }

  acceptClick() {
    console.log('accept');

    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxWidth = '500px';

    this.revolvingStore
      .sendRefund(this.refundDataForm)
      .then(
        (data) => {
          console.log('send ok');

          dialogConfig.data = {
            title: this.translate.instant('refunds.dialog.authorizedOperation.title'),
            text: this.translate.instant('refunds.dialog.authorizedOperation.text'),
            icon: 'icon-ic_circle_check',
          };
          const dialog = this.dialog.open(ResponseDialogComponent, dialogConfig);
          dialog
            .afterClosed()
            .toPromise()
            .then(
              () => {
                this.printStore.dowloadTPVRefundPrint(data.datosBoletaBean);
              },
              (error) => console.error(error)
            );
        },
        (error) => {
          console.log('send error: ', error);
          let errorMsg = error.error?.result
            ? error.error?.result
            : this.translate.instant('refunds.dialog.incorrectInformation.text');
          dialogConfig.data = {
            title: this.translate.instant('refunds.dialog.incorrectInformation.title'),
            text: errorMsg,
            icon: 'icon-ic_circle_cross',
          };
          this.dialog.open(ResponseDialogComponent, dialogConfig);
        }
      )
      .finally(() => {
        this.refundDataForm.reset();
      });
  }

  getFormattedAmount() {
    this.formattedAmount = this.customValidators.transformAmount(this.amount);
    this.amount = this.formattedAmount;
  }

  numberOnly(event: any): boolean {
    return this.customValidators.numberOnly(event.which ? event.which : event.keyCode, this.amount);
  }

  isGenericSelect() {
    return this.establishmentsList?.length < MAX_SELECTOR_DATA;
  }

  handleSelectionChange(event: any) {
    if (
      this.refundDataForm.controls.establishment?.value == '' ||
      this.refundDataForm.controls.establishment?.value == null
    ) {
      this.refundDataForm.controls.establishment.setValue(event.value);
    }
  }
}
